module.exports = __webpack_public_path__ + "img/hcml_gallery2.68a3cc49.jpg";